import { createContext } from "react";

export const BranchOfficesContext = createContext(null); 